import { Link } from "@/i18n/routing";
import {
  DeleteButton,
  EditQuantityButton,
  MoveToWishlistButton,
} from "@repo/components";
import { formProductOptionsString } from "@repo/lib/helpers";
import { Media, ProductPrice } from "@repo/ui";
import cx from "classnames";

const CartItems = (props) => {
  const { products, miniCart, handleClose, t } = props;

  return (
    <>
      {products?.map((item) => {
        const productOptions = formProductOptionsString(item);
        return (
          <div className="border-miniCart-border border-b py-4" key={item?.id}>
            <div
              className={cx("flex", {
                "pb-0": !miniCart,
              })}
            >
              <Link
                href={`/${item?.slug}`}
                className={cx("block hover:opacity-70", {
                  "relative w-[82px] md:h-[80px] md:w-[80px]": miniCart,
                  "relative w-[88px] md:h-[80px] md:w-[80px]": !miniCart,
                })}
                onClick={handleClose ? handleClose : null}
              >
                <Media
                  src={item?.image?.imageURI}
                  alt={item?.name}
                  width={item?.image?.width}
                  height={item?.image?.height}
                  className="mx-auto"
                />
              </Link>

              <div
                className={cx("text-sm", {
                  "w-[140px] ps-2 md:w-[160px] md:px-2": miniCart,
                  "w-[180px] ps-3 md:w-[400px] md:ps-6 md:portrait:w-80":
                    !miniCart,
                })}
              >
                <Link
                  href={`/${item?.slug}`}
                  className="text-miniCart-text line-clamp-3 pb-1 font-medium uppercase leading-5 tracking-wide hover:underline"
                  onClick={handleClose ? handleClose : null}
                >
                  {item?.name}
                </Link>
                {productOptions && (
                  <span className="text-miniCart-subText text-sm font-medium">
                    {productOptions}
                  </span>
                )}
              </div>
              <div className="ms-auto">
                <ProductPrice
                  price={item?.formattedPrice}
                  salePrice={item?.formattedSalePrice}
                  discount={item?.discount}
                  variant="cart"
                />
              </div>
            </div>
            <div className="mt-3 flex items-center">
              <div className="flex rtl:space-x-3">
                <MoveToWishlistButton item={item} miniCart={miniCart} />
                <DeleteButton item={item} />
              </div>
              {item?.isStockStatus && item?.active ? (
                <div className="ms-auto">
                  <div className="border-miniCart-cartItems-quantityButtonBorder flex items-center border-y">
                    <EditQuantityButton item={item} type="minus" />
                    <span className="text-miniCart-cartItems-quantityText text-bold min-w-[42px] max-w-[42px] px-3 text-center text-sm">
                      {item?.quantity}
                    </span>
                    <EditQuantityButton item={item} type="plus" />
                  </div>
                </div>
              ) : (
                <div className="bg-supportiveGray ms-auto flex h-9 items-center px-4 font-medium text-white md:h-11 rtl:px-2.5 rtl:text-xs">
                  {t("Out_Of_Stock")}
                </div>
              )}
            </div>
          </div>
        );
      })}
    </>
  );
};

export default CartItems;
